export default "__VITE_ASSET__d739adfa__"